// extracted by mini-css-extract-plugin
export var isShyHeaderMode = "BypUG";
export var overlayLeftPane = "_ybNL";
export var overlayLeftPaneBelowRibbon = "Pga5o";
export var overlayLeftPaneBelowRibbonWin32Overlay = "eqaOw";
export var overlayLeftPaneMain = "QAQPf";
export var overlayLeftPaneScrollableContent = "XWj4y";
export var overlayLeftPaneScrollableContentNoScroll = "C7Hc5";
export var overlayLeftPaneWithAppNames = "XouY9";